import React, { Component } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import actions from '../../redux/actions';
import Contribution from './Contribution';
import Credit from './Credit';
import LicensingPermissions from './LicensingPermissions';
import GoverningLaw from './GoverningLaw';
import NameLikeness from './NameLikeness';
import Indemnification from './Indemnification';
import DisputeResolution from './DisputeResolution';
import CureRemedies from './CureRemedies';
import Consideration from './Consideration';
// For producer agreement
import Services from './Services';
import Ownership from './Ownership';
import Payments from './Payments';
import CreditNameLikeness from './CreditNameLikeness';

class ContractBlock extends Component {
  filter = (agreement, contractBlocks) => {
    const blocks = R.filter(
      (block) =>
        (agreement.type === 'premium' &&
          block['block_type'].includes('premium') === true) ||
        (agreement.type === 'workforhire' &&
          block['block_type'].includes('work_for_hire') === true) ||
        (agreement.type === 'producer' &&
          block['block_type'].includes('producer') === true),
      contractBlocks
    );

    R.sortBy(R.prop('id'))(blocks);
    return blocks;
  };

  render() {
    const filterBlocks = this.filter(this.props.agreement, this.props.blocks);

    switch (this.props.block.name) {
      case 'Contribution':
        return <Contribution {...this.props} filterBlocks={filterBlocks} />;
      case 'Credit':
        return <Credit {...this.props} filterBlocks={filterBlocks} />;
      case 'Licensing Permissions':
        return (
          <LicensingPermissions {...this.props} filterBlocks={filterBlocks} />
        );
      case 'Governing Law':
        return <GoverningLaw {...this.props} filterBlocks={filterBlocks} />;
      case 'Name & Likeness':
        return <NameLikeness {...this.props} filterBlocks={filterBlocks} />;
      case 'Indemnification':
        return <Indemnification {...this.props} filterBlocks={filterBlocks} />;
      case 'Dispute Resolution':
        return (
          <DisputeResolution {...this.props} filterBlocks={filterBlocks} />
        );
      case 'Cure; Remedies':
        return <CureRemedies {...this.props} filterBlocks={filterBlocks} />;
      case 'Consideration':
        return <Consideration {...this.props} filterBlocks={filterBlocks} />;

      case 'Services':
        return <Services {...this.props} filterBlocks={filterBlocks} />;
      case 'Ownership':
        return <Ownership {...this.props} filterBlocks={filterBlocks} />;
      case 'Payments':
        return <Payments {...this.props} filterBlocks={filterBlocks} />;
      case 'Credit; Name and Likeness':
        return (
          <CreditNameLikeness {...this.props} filterBlocks={filterBlocks} />
        );
      default:
        return null;
    }
  }
}

const mapStateToProps = (state) => ({
  agreement: state.agreements.selectedAgreement,
  fields: state.create.fields,
  blocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  members: state.users.members,
  workOwnerships: state.workOwnerships.workOwnerships,
});

const mapDispatchToProps = (dispatch) => ({
  updateBlock(id, content, options) {
    dispatch(actions.updateContractBlockContent(id, content, options));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractBlock);



// WEBPACK FOOTER //
// src/components/ContractBlock/index.jsx